import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NavDrawer from "./NavDrawer";
import i18next from "i18next";
import { Pages } from "../../constants";
import { BasicSelect as TransLang } from "./TransLang";

function NavBar({ data }) {
    let lng = i18next.language;
    const isRtl = lng === "ar"; // التحقق من إذا كانت اللغة عربية لضبط الاتجاه
    const [drawer, setDrawer] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

    const general = data?.general || {};
    const logoUrl = general?.image;

    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    bgcolor: "transparent", // جعل الخلفية الأساسية شفافة لتظهر الحاوية الداخلية كبطاقة مستقلة
                    transition: "all 0.3s",
                    zIndex: 999,
                    top: scrolled ? 0 : 50, // إضافة مسافة علوية عند عدم التمرير
                    px: { xs: 2, md: 8 },
                }}
            >
                {/* الحاوية المخصصة للشريط الداخلي لمحاكاة التصميم المرفق */}
                <Toolbar
                    disableGutters
                    sx={{
                        bgcolor: "#FFFFFF",
                        border: "1px solid #E5D5BC", // لون البوردر الذهبي الخفيف المحاكي للصورة
                        borderRadius: "12px", // انحناء الحواف الدائرية
                        boxShadow: scrolled ? "0px 4px 20px rgba(0,0,0,0.05)" : "none",
                        px: { xs: 2, md: 4 },
                        py: 1,
                        width: "100%",
                        maxWidth: "1400px",
                        mx: "auto",
                        display: "flex",
                        flexDirection: isRtl ? "row" : "row", // دعم الاتجاه من اليمين لليسار
                    }}
                >
                    {/* شاشات الـ Desktop */}
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: { md: "flex", xs: "none" },
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexDirection: isRtl ? "row" : "row",
                        }}
                    >
                        {/* الشعار (Logo) */}
                        <Link to="/" style={{ textDecoration: "none" }}>
                            {logoUrl ? (
                                <Box
                                    component="img"
                                    src={logoUrl}
                                    alt="logo"
                                    sx={{ height: 50, width: "auto", display: "block" }}
                                />
                            ) : (
                                <Box sx={{ color: "#1A1A1A", fontWeight: 700, fontSize: 22 }}>
                                    {general?.site_name || 'Logo'}
                                </Box>
                            )}
                        </Link>

                        {/* القوائم (Navigation Links) */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: { md: 4, lg: 6 }, // مسافات متناسقة بين اللينكات
                                flexDirection: isRtl ? "row" : "row"
                            }}
                        >
                            {Pages?.map((page, i) => (
                                <NavLink
                                    key={i}
                                    to={page.path}
                                    onClick={scrollToTop}
                                    style={({ isActive }) => ({
                                        textDecoration: "none",
                                        fontSize: 16,
                                        fontWeight: isActive ? 700 : 500,
                                        color: isActive ? "#C59850" : "#1A1A1A",
                                        textTransform: "capitalize",
                                        position: "relative",
                                        paddingBottom: 8,
                                        // إضافة الخط السفلي الذهبي عند التفعيل (Active) مطابق للصورة
                                        borderBottom: isActive ? "2px solid #C59850" : "2px solid transparent",
                                        transition: "color 0.2s, border-color 0.2s",
                                    })}
                                >
                                    {lng === "ar" ? page.name : page.name_en}
                                </NavLink>
                            ))}
                        </Box>

                        {/* أداة تغيير اللغة */}
                        <TransLang />
                    </Box>

                    {/* شاشات الـ Mobile */}
                    <Box
                        sx={{
                            display: { md: "none", xs: "flex" },
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                            flexDirection: isRtl ? "row" : "row",
                        }}
                    >
                        <Link to="/" style={{ textDecoration: "none", height: 50 }}>
                            {logoUrl ? (
                                <Box
                                    component="img"
                                    src={logoUrl}
                                    alt="logo"
                                    sx={{ height: 45, width: "auto" }}
                                />
                            ) : (
                                <Box sx={{ color: "#1A1A1A", fontWeight: 700, fontSize: 18 }}>
                                    {general?.site_name || 'Logo'}
                                </Box>
                            )}
                        </Link>
                        <IconButton onClick={() => setDrawer(true)}>
                            <MenuIcon sx={{ fontSize: "1.8rem", color: "#1A1A1A" }} />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            <NavDrawer drawer={drawer} setDrawer={setDrawer} logoUrl={logoUrl} pages={Pages} />
        </>
    );
}

export default NavBar;